import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Heading,
  VStack,
  Text,
  Image,
  useToast,
  Spinner,
} from "@chakra-ui/react";

import { useLocation, useNavigate } from "react-router-dom";
import { designBackgroundApi } from "../../../api/designBackground";
import { DEFAULT_BOX } from "../constant";
import StepHeader from "./StepHeader";

const BASE_URL = process.env.REACT_APP_BACKEND_API;

export default function Step3Generate() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const toast = useToast();

  const [loading, setLoading] = useState(true);
  const [layoutId, setLayoutId] = useState(null);

  const isInvalid = !state?.imageUrl || !state?.name;

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (isInvalid) return;
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    const init = async () => {
      const loadingToast = toast({
        status: "loading",
        title: "Đang khởi tạo layout...",
        duration: null,
        isClosable: false,
      });

      try {
        const payload = {
          name: state.name.trim(),
          url: state.imageUrl,
          layout: {
            refW: 1080,
            refH: 1620,
            ...DEFAULT_BOX,
          },
        };

        const res = await designBackgroundApi.createLayout(payload);

        const newId = res?.data?._id || res?._id;
        setLayoutId(newId);

        toast.close(loadingToast);
        toast({
          status: "success",
          title: "Khởi tạo thành công!",
        });
      } catch (e) {
        console.log("khoi tao layout err", e);
        toast.closeAll();
        toast({
          status: "error",
          title: "Không khởi tạo được layout!",
        });
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [isInvalid, toast, state]);

  const next = () => {
    if (!layoutId) {
      toast({
        status: "error",
        title: "Layout ID không hợp lệ!",
      });
      return;
    }
    navigate(`/design-background/edit/${layoutId}`);
  };

  return (
    <Box p={6} w={"full"} display={"flex"} alignItems={"center"} flexDirection={"column"}>
      <StepHeader step={2} />

      <Box maxW="480px">
        <Heading size="md" mb={4}>
          Bước 3: Hoàn tất khởi tạo
        </Heading>
        <VStack spacing={4} align="stretch">
          {isInvalid ? (
            <Text>Thiếu dữ liệu. Hãy bắt đầu lại từ Step 1.</Text>
          ) : (
            <>
              <Text>Ảnh Banner bạn đã tải lên:</Text>
              <Image
                src={BASE_URL + "/" + state.imageUrl}
                alt="preview"
                borderRadius="md"
                border="1px solid #ddd"
                maxH="380px"
                objectFit="contain"
              />
              {loading ? (
                <Spinner size="lg" alignSelf="center" mt={4} />
              ) : (
                <Button colorScheme="blue" onClick={next}>
                  Đi đến trình chỉnh sửa
                </Button>
              )}
            </>
          )}
        </VStack>
      </Box>
    </Box>
  );
}
